//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { storage } from "../main";
export default {
  data() {
    return {
      styles: [
        {
          name: "Standard",
          dances: "Waltz, Tango, Viennese Waltz, Foxtrot, Quickstep",
          imgurl:
            "https://images.squarespace-cdn.com/content/v1/60e5d5fb49923435b63a7b50/1625687367894-SQ2CVXWHAR68HW50KKLX/d749469e003595274ee560706a898627.jpg?format=750w",
        },
        {
          name: "Latin",
          dances: "Cha Cha, Rumba, Samba, Paso Doble, Jive",
          imgurl:
            "https://images.squarespace-cdn.com/content/v1/60e5d5fb49923435b63a7b50/1625687377930-BHWLDU2VIMM0SE716RFU/latin.jpg?format=500w",
        },
        {
          name: "Smooth",
          dances: "Waltz, Tango, Foxtrot, Viennese Waltz",
          imgurl:
            "https://images.squarespace-cdn.com/content/v1/60e5d5fb49923435b63a7b50/1625687387554-CMQPZ81YF9N3QUQ2ZLBG/smooth.png?format=750w",
        },
        {
          name: "Rhythm",
          dances: "Cha Cha, Rumba, Swing, Mambo, Bolero",
          imgurl:
            "https://images.squarespace-cdn.com/content/v1/60e5d5fb49923435b63a7b50/1625687397458-JATOPCESG769TYF2MA53/rhythm.jpg?format=750w",
        },
      ],
    };
  },
  mounted() {
    var imgRefs = [
      "StandardCover.jpg",
      "LatinCover.jpg",
      "SmoothCover.jpg",
      "RhythmCover.jpg",
    ];
    imgRefs.forEach((img, idx) => {
      storage
        .ref(img)
        .getDownloadURL()
        .then((url) => {
          this.styles[idx].imgurl = url;
        });
    });
  },
};
